import { JsonObject, JsonProperty } from 'json2typescript';

import { AddressInterface } from '../../../core';
import { StringAdapter } from '../../client/helpers/serializer/adapters/string.adapter';

@JsonObject('Address')
export class Address implements AddressInterface {
    @JsonProperty('StreetType', StringAdapter, true)
    private _streetType: string = undefined;

    @JsonProperty('Street', StringAdapter, true)
    private _street: string = undefined;

    @JsonProperty('Number', StringAdapter, true)
    private _number: string = undefined;

    @JsonProperty('Stair', StringAdapter, true)
    private _stair: string = undefined;

    @JsonProperty('Floor', StringAdapter, true)
    private _floor: string = undefined;

    @JsonProperty('Door', StringAdapter, true)
    private _door: string = undefined;

    @JsonProperty('City', StringAdapter, true)
    private _city: string = undefined;

    @JsonProperty('State', StringAdapter, true)
    private _state: string = undefined;

    @JsonProperty('PostalCode', StringAdapter, true)
    private _postalCode: string = undefined;

    @JsonProperty('Country', StringAdapter, true)
    private _country: string = undefined;

    get streetType(): string {
        return this._streetType;
    }

    set streetType(value: string) {
        this._streetType = value;
    }

    get street(): string {
        return this._street;
    }

    set street(value: string) {
        this._street = value;
    }

    get number(): string {
        return this._number;
    }

    set number(value: string) {
        this._number = value;
    }

    get stair(): string {
        return this._stair;
    }

    set stair(value: string) {
        this._stair = value;
    }

    get floor(): string {
        return this._floor;
    }

    set floor(value: string) {
        this._floor = value;
    }

    get door(): string {
        return this._door;
    }

    set door(value: string) {
        this._door = value;
    }

    get city(): string {
        return this._city;
    }

    set city(value: string) {
        this._city = value;
    }

    get state(): string {
        return this._state;
    }

    set state(value: string) {
        this._state = value;
    }

    get postalCode(): string {
        return this._postalCode;
    }

    set postalCode(value: string) {
        this._postalCode = value;
    }

    get country(): string {
        return this._country;
    }

    set country(value: string) {
        this._country = value;
        this._state = undefined;
    }

    equals(address: AddressInterface): boolean {
        return (
            this.streetType === address.streetType &&
            this.street === address.street &&
            this.number === address.number &&
            this.door === address.door &&
            this.city === address.city &&
            this.state === address.state &&
            this.postalCode === address.postalCode &&
            this.country === address.country
        );
    }

    isComplete(): boolean {
        return !!this.streetType && !!this.street && !!this.number && !!this.state && !!this.city && !!this.postalCode && !!this.country;
    }
}
